export enum SavedFilterTypeEnum {
    monitoring = 'MONITORING',
    discover = 'DISCOVER'
}
